<template>
  <div class="vch-variant-image">
    <picture v-if="currentVariantEAN !== null && variantImageSrc['525']">
      <source
        key="715"
        :srcset="variantImageSrc['715']"
        media="(min-width: 1600px)" />
      <source
        key="600"
        :srcset="variantImageSrc['600']"
        media="(min-width: 1280px)" />
      <source
        key="420"
        :srcset="variantImageSrc['420']"
        media="(min-width: 1024px)" />
      <source
        key="728"
        :srcset="variantImageSrc['728']"
        media="(min-width: 425px)" />
      <img key="525" alt="variant Image" :src="variantImageSrc['525']"
    /></picture>
    <slot v-else />
  </div>
</template>

<script>
import { eventBus } from 'EventBus/';
import { busName as variantSelectorBus } from 'Directives/variant-selector/variant-selector';

const emptyImageSrcs = {
  715: '',
  600: '',
  420: '',
  728: '',
  350: '',
  525: ''
};

export default {
  name: 'vch-variant-image',
  props: {
    variantImageData: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      currentVariantEAN: null,
      variantSourceData: null,
    };
  },
  computed: {
    variantImageSrc() {
      if (!this.currentVariantEAN) return emptyImageSrcs;
      return {
        ...emptyImageSrcs,
        ...this.variantSourceData[this.currentVariantEAN],
      };
    },
  },
  mounted() {
    eventBus.$on(`${variantSelectorBus}::selected`, this.updateVariantEAN);

    this.variantSourceData =
      typeof this.variantImageData === 'string'
        ? JSON.parse(this.variantImageData)
        : this.variantImageData;

    // Check channel advisor for potential new variant ID
    const channelAdvisor = document.getElementById('channelAdvisor');
    if (channelAdvisor && channelAdvisor.dataset.variantid) {
      this.updateVariantEAN(channelAdvisor.dataset.variantid);
    }
  },
  beforeDestroy() {
    eventBus.$off(`${variantSelectorBus}::selected`, this.updateVariantEAN);
  },
  methods: {
    updateVariantEAN(variantEAN) {
      if (variantEAN !== this.currentVariantEAN) {
        this.currentVariantEAN = variantEAN;
      }
    },
  },
};
</script>
